export default __webpack_public_path__ + "static/media/inhouse-icon2.aca71c46.svg";